/**
 * Which copy of the factory this tab is on, from its host name, so local and development copies can't be
 * mistaken for production (the sidebar badge and the tab title).
 */
export const PRODUCTION_HOST = 'factory.stakara.com';

export type AppEnvironment = 'production' | 'local' | 'dev';

const PRIVATE_IPV4 = /^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|127\.)/;

export function appEnvironment(hostname: string): AppEnvironment {
  const host = hostname.toLowerCase();
  if (host === PRODUCTION_HOST) return 'production';
  if (host === 'localhost' || host.endsWith('.localhost') || host === '::1' || host === '[::1]' || host.endsWith('.ts.net') || PRIVATE_IPV4.test(host)) {
    return 'local';
  }
  return 'dev';
}

/** The badge text for a non-production copy, or null in production. */
export function environmentLabel(env: AppEnvironment): string | null {
  return env === 'production' ? null : env === 'local' ? 'LOCAL' : 'DEV';
}

/** This tab's environment. */
export function currentEnvironment(): AppEnvironment {
  return typeof window === 'undefined' ? 'production' : appEnvironment(window.location.hostname);
}
